module.exports = __webpack_public_path__ + "static/media/logo.c0b59d0b.png";